/**
 * Matches the asset selector format: `<chainId>:<address>` (e.g. `1:0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48`).
 */
const ASSET_SELECTOR_REGEX = /^\d+:0x[a-fA-F0-9]{40}$/

/**
 * Filters out invalid asset selector values from URL params.
 * Protects against stale bookmarks containing legacy GraphQL UUIDs
 * from the Blue API → Consumer API migration (Feb 2026).
 *
 * TODO: Remove once stale bookmarks have aged out (VMV1-4777).
 */
export function filterValidAssetSelectors(values: string[] | undefined): string[] | undefined {
  if (!values?.length) return undefined
  const valid = values.filter(v => ASSET_SELECTOR_REGEX.test(v))
  return valid.length ? valid : undefined
}

/**
 * Dedupes `chainId:address` selectors and drops those whose chain is not being
 * queried; the API would match nothing for them anyway. When pruning would
 * empty the list, the deduped original list is kept so the API still returns
 * an empty set — dropping the filter entirely would widen the results instead.
 */
export function filterAssetSelectorsByChainIds(
  values: string[] | undefined,
  chainIds: number[] | undefined
): string[] | undefined {
  if (!values?.length) return undefined
  const deduped = [...new Set(values)]
  if (!chainIds?.length) return deduped
  const allowed = new Set(chainIds.map(String))
  const kept = deduped.filter(v => allowed.has(v.split(':')[0] ?? ''))
  return kept.length ? kept : deduped
}
